import { styled } from '@/styled-system/jsx';
import { css } from '@/styled-system/css';

export const HdpPhotoGalleryV2ContentHeight = 230;
export const HdpPhotoGalleryV2ContentHeightXl = 332;

export const HdpPhotoGalleryWrapper = styled('div', {
  base: {
    position: 'relative',
    height: {
      base: `${HdpPhotoGalleryV2ContentHeight}px`,
      xxl: `${HdpPhotoGalleryV2ContentHeightXl}px`,
    },
    padding: {
      base: '0 16px',
      xxl: '0px',
    },
    maxWidth: {
      xxl: '830px',
    },
    margin: {
      xxl: '0 auto',
    },
  },
});

export const HdpPhotoGalleryContent = styled('div', {
  base: {
    position: 'relative',
    height: {
      base: `${HdpPhotoGalleryV2ContentHeight}px`,
      xxl: `${HdpPhotoGalleryV2ContentHeightXl}px`,
    },
    borderRadius: '8px',
    overflow: 'hidden',
  },
});

export const HdpPhotoGalleryListingAgent = styled('div', {
  base: {
    bottom: '24px',
    color: 'hpxWhite',
    fontSize: 'sm',
    fontWeight: 'normal',
    left: '16px',
    position: 'absolute',
  },
});

export const HdpPhotoGalleryTagWrapper = styled('div', {
  base: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    justifyContent: 'center',
    left: '16px',
    position: 'absolute',
    top: {
      base: '8px',
      xxl: '16px',
    },
  },
});

export const hdpPhotoGalleryTagStyles = css({
  '& .Tooltip-children': {
    borderBottom: '0px',
  },
});

export const HdpPhotoGalleryTagIcon = styled('img', {
  base: {
    display: 'inline-block',
    height: '18px',
    paddingRight: '8px',
    verticalAlign: 'top',
    width: '24px',
  },
});

export const NoPhoto = styled('img', {
  base: {
    height: '100%',
    width: '100%',
    borderRadius: '8px',
    objectFit: 'cover',
  },
});

export const ImagePlaceholder = styled('div', {
  base: {
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
});
